import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Disclosure } from '@headlessui/react';

export default function MobileNavDropdown({ title, links, nested = false, topLink = '' }) {
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <Disclosure as="div">
      {({ open }) => (
        <>
          <Disclosure.Button
            className={classNames(
              'flex w-full items-center justify-between rounded-lg py-2 pr-3.5 text-base font-semibold leading-7 text-white hover:bg-gray-600',
              nested ? 'pl-6' : 'pl-3'
            )}
            href={topLink}
          >
            <a className="text-white hover:bg-gray-600 no-underline" href={topLink}>
              {title}
            </a>
            <ChevronDownIcon
              className={classNames(open ? 'rotate-180' : '', 'h-5 w-5 flex-none')}
              aria-hidden="true"
            />
          </Disclosure.Button>
          <Disclosure.Panel className="mt-2 space-y-2">
            {links.map((link) => (
              <div key={link.name} className={link.nestedLinks ? '' : ''}>
                {link.nestedLinks ? (
                  <MobileNavDropdown
                    title={link.name}
                    links={link.nestedLinks}
                    nested="true"
                    topLink={link.href}
                  />
                ) : (
                  <Disclosure.Button
                    as="a"
                    href={link.href}
                    className={classNames(
                      'block rounded-lg py-2 pr-3 font-bold leading-7 text-white hover:bg-gray-600 no-underline',
                      nested ? 'pl-9' : 'pl-6'
                    )}
                  >
                    {link.name}
                  </Disclosure.Button>
                )}
              </div>
            ))}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
